<template>
  <div class="file-content w-100">
    <!-- UPLOADED CONTENT -->
    <div class="uploaded-content row">
      <div
        class="content rounded-5 ml-2"
        :class="full_width ? 'w-100' : null"
        v-for="(file, index) in files"
        :key="index"
      >
        <div class="left">
          <!-- FILE IMAGE -->
          <div class="avatar avatar-square brand_accent">
            <img
              v-lazy="localImg(fileType(file.extension))"
              alt
              class="avatar-img"
            />
          </div>

          <!-- FILE INFO -->
          <div class="file-info">
            <div class="file-title brand_navy">{{ file.shortenName }}</div>
            <div class="file-meta color_grey_dark">
              {{ file.extension | toUppercase }}
              {{ file.size }}
            </div>
          </div>
        </div>

        <!-- RIGHT -->
        <div class="right">
          <div class="avatar avatar_sm border pointer">
            <span
              @click="$emit('remove-file', index)"
              class="icon-thrash border_grey_dark font-18 flex-center"
            ></span>
          </div>
        </div>
      </div>
    </div>
    <!-- / UPLOADED CONTENT -->
  </div>
</template>

<script>
export default {
  name: "FileAttachmentPreview",

  props: {
    files: Array,
    full_width: {
      type: Boolean,
      default: false,
    },
  },

  filters: {
    toUppercase(val) {
      return val.toUpperCase();
    },
  },

  methods: {
    fileType(ext) {
      let fileExt = ext;
      switch (fileExt) {
        case "pdf":
          fileExt = "PDFFILE.svg";
          break;
        case "ppt":
          fileExt = "PPTFILE.svg";
          break;
        case "pptx":
          fileExt = "PPTFILE.svg";
          break;
        case "doc":
          fileExt = "DOCFILE.svg";
          break;
        case "docx":
          fileExt = "DOCXFILE.svg";
          break;
        case "xls":
          fileExt = "XLSFILE.svg";
          break;
        case "xlsx":
          fileExt = "XLSFILE.svg";
          break;
        case "txt":
          fileExt = "TxtFile.svg";
          break;
        case "epub":
          fileExt = "DOCEPUB.png";
          break;
        case "mp4":
          fileExt = "VIDMP4.png";
          break;
        default:
          fileExt = "PDFFILE.svg";
          break;
      }
      return fileExt;
    },
  },
};
</script>

<style lang="scss" scoped>
.file-content {
  .uploaded-content {
    margin-top: 10px;

    .content {
      background: $color_white;
      @include flex_row_between_nowrap;
      width: 48%;
      border: 1px solid $border_grey;
      padding: 10px;
      margin-bottom: 8px;
      transition: all 0.4s ease-in-out;
      transform: scale(1.01);

      @include breakpoint_max(lg) {
        width: 95% !important;
      }

      .left {
        @include flex_row_start_nowrap;

        .avatar {
          @include equal_min_edge(40);
          margin-right: 10px;

          img {
            @include transform_center;
            @include equal_min_edge(35);
          }
        }

        .file-title {
          font-size: 14px;
          line-height: 19px;
          margin-bottom: 5px;
        }

        .file-meta {
          font-size: 12px;
          line-height: 16px;
        }
      }
      .right {
        .avatar {
          span {
            transition: all 0.3s ease-in-out;
          }
          &:hover {
            span {
              color: $brand_tonic !important;
            }
          }
        }
      }
    }
  }
}
</style>
